import is from '@sindresorhus/is';
import { createContext, useRef } from 'react';

import { createAlignmentStore } from './alignment-store';

import type { AlignmentStore } from './alignment-store';
import type { FunctionComponent, PropsWithChildren } from 'react';
import type { StoreApi } from 'zustand';

export const AlignmentContext = createContext<StoreApi<AlignmentStore> | null>(null);

export const AlignmentContextProvider: FunctionComponent<PropsWithChildren> = (properties) => {
    const storeRef = useRef<StoreApi<AlignmentStore>>(undefined);

    if (is.undefined(storeRef.current)) {
        storeRef.current = createAlignmentStore();
    }

    return <AlignmentContext.Provider value={storeRef.current}>{properties.children}</AlignmentContext.Provider>;
};
